<script>

import { connect, h, mapProps, mapReadPretty } from '@formily/vue'
import { defineComponent } from 'vue-demi'

import { Select as RichSelect } from '@didi/rich-ui'
import { SelectPreviewText } from '../PreviewText'
import './style.scss'

const SelectOption = defineComponent({
  name: 'Select',
  props: ['options'],
  setup (customProps, { attrs, slots, listeners }) {
    return () => {
      const options = (customProps.options || []).map(item => ({...item, text: item.label}))
      return h(
        RichSelect,
        {
          attrs: {
            ...attrs
          },
          props: {
            options
          },
          on: listeners
        },
        []
      )
    }
  }
})

export const Select = connect(
  SelectOption,
  mapProps({ dataSource: 'options', loading: true }),
  mapReadPretty(SelectPreviewText)
)

export default Select

</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
